<template>
</template>
<script>
    import HamburgerOptionsMixin from "../../../author/pagesbuilder/mixins/HamburgerOptionsMixin";

    export default {
        name: "IconElement",
        mixins: [HamburgerOptionsMixin],
        data() {
            return {
                elementType: 'icon',
            }
        },
    }
</script>
